<template>
	<div class="content-wrap" ref="container">
		<!-- 搜索表单 -->
		<search-form
			@search="search"
			ref="dispatchSearchRef"
			class="searchform-style customer-list-form"
		></search-form>

		<!-- 按钮组 + 列设置（在 table-fixed 的 toolbar 中） -->
		<!-- table展示区 -->
		<div class="table-scroll-wrap">
			<div style="height:75%;">
				<table-fixed
					:isSelect="true"
					:loading="loading"
					:tableData="tableData"
					:tableColumn="columns"
					:columnSettingsKey="$route.name"
					:lockedColumnKeys="['index']"
					@onSelectChange="onSelectChange"
					@dbclickRow="dbclickRow"
					:pagination="pagination"
					v-bind:class="isActive ? 'active' : 'static'"
				>
					<template v-slot:toolbar>
						<control-buttons
							ref="controlBut"
							:selectedRows="selectedRows"
							@success="success"
						></control-buttons>
						<a-button @click="showAttachment" size="small" type="primary"
							>{{ $t('businessDispatch.viewAttachment') }}</a-button
						>
					</template>
					<!-- <template v-slot:option="scope">
						<a @click="showAttachment(scope)">点击查看</a>
					</template> -->
				</table-fixed>
				<a-modal
					:bodyStyle="{ padding: 0 }"
					:mask="true"
					width="80%"
					wrapClassName="attachClass"
					:dialogStyle="{}"
					dialogClass="dialogClass"
					:maskStyle="{}"
					:title="
						(h) => {
							return h('div', [h('span', $t('businessDispatch.viewAttachment'))]);
						}
					"
					:visible="visibleAttach"
					@cancel="closeAttach"
				>
					<template>
						<div :style="{ height: '100%' }">
							<div :style="{ height: '94%' }">
								<template
									v-if="
										attach[current - 1] &&
											attach[current - 1].type.search(/^(jp|png)/i) != -1
									"
								>
									<div class="attactment-wrap">
										<img
											@mousedown="imgMove"
											:src="attach[current - 1].url"
											alt=""
											class="imgStyle"
											:style="imgStyle"
											ref="imageBox"
										/>
									</div>
								</template>
								<template v-else-if="attach[current - 1]">
									<iframe
										:src="previewFile(attach[current - 1].url)"
										:style="{ height: '100%', width: '100%' }"
										frameborder="0"
									></iframe>
								</template>
							</div>
							<div class="attachment-footer">
								<!--left-->
								<div class="opt-left">
									<!-- <a
									class=""
									@click="
										downloadFile(
											attach[current - 1]
												? attach[current - 1].attachmentId
												: '',
											attach[current - 1]
												? attach[current - 1].attachmentId +
														'.' +
														attach[current - 1].name.split('.')[1]
												: '',
											''
										)
									"
								>
									<a-icon
										type="download"
										:style="{
											cursor: 'pointer',
											fontSize: '20px',
											color: 'red',
										}"
										title="下载"
									/>
								</a> -->
									<a
										class=""
										@click="
											downloadFile(
												'',
												$t('businessDispatch.billNumber') + attach[current - 1].blNumber + `${$t('businessDispatch.viewAttachment')}.zip`,
												containerId
											)
										"
									>
										<a-icon
											type="download"
											:style="{
												cursor: 'pointer',
												fontSize: '20px',
												color: 'blue',
												borderBottom: '1px solid',
											}"
											title="批量下载"
										/>
									</a>
								</div>
								<!--middle-->
								<div class="opt-middle">
									<span>
										{{ $t('businessDispatch.accessoryName') }}:
										{{
											attach[current - 1] ? $t(attach[current - 1].fileName) : $t('businessDispatch.noInformation')
										}}</span
									>
								</div>
								<div class="change-img-size">
									<a
										style="marginRight:15px;"
										class=""
										@click="
											downloadFile(
												attach[current - 1]
													? attach[current - 1].attachmentId
													: '',
												attach[current - 1]
													? attach[current - 1].attachmentId +
															'.' +
															attach[current - 1].name.split('.')[1]
													: '',
												''
											)
										"
									>
										<a-icon
											type="download"
											:style="{
												cursor: 'pointer',
												fontSize: '20px',
												color: 'red',
											}"
											title="下载"
										/>
									</a>
									<a-button size="small" @click="toBIgChange">
										<a-icon type="zoom-in" />
									</a-button>
									<a-button size="small" @click="toSmallChange">
										<a-icon type="zoom-out" />
									</a-button>
									<a-button size="small" @click="rotateLeft()"
										><a-icon type="redo"
									/></a-button>
								</div>
								<!--right-->
								<div class="opt-right">
									<a-row type="flex" justify="space-around" align="middle">
										<a-col
											:span="4"
											:title="$t('previousPage')"
											class="optPage left"
											onselectstart="return false"
										>
											<a-icon
												type="left"
												:class="current == 1 ? 'notAllow' : 'allow'"
												@click="preImg"
											/>
										</a-col>
										<a-col :span="16">
											<a-input
												size="small"
												class="jup"
												:title="current + '/' + attach.length"
												v-model.number="currentValue"
												@blur="onBlur"
												@keyup.enter.native="keyup"
											></a-input>
											<span style="margin: 0 8px;">/</span>
											<span>{{ attach.length }}</span>
										</a-col>
										<a-col
											:span="4"
											:title="$t('nextPage')"
											class="optPage right"
											onselectstart="return false"
										>
											<a-icon
												type="right"
												:class="current == attach.length ? 'notAllow' : 'allow'"
												@click="nextImg"
											/>
										</a-col>
									</a-row>
								</div>
							</div>
						</div>
					</template>

					<template slot="footer" class="footer">
						<a-button key="back" @click="closeAttach">
							{{ $t('close') }}
						</a-button>
						<!-- <a-button type="primary" @click="mulDown">批量下载</a-button> -->
					</template>
				</a-modal>
			</div>
		</div>
	</div>
</template>
<script>
import searchForm from "./searchform";
import tableFixed from "./table-fixed.vue";
import controlButtons from "../../components/control-buttons.vue";
import {
	orderlist,
	containerAttachments,
	downloadAttachment,
} from "../../api/business-dispatch";
import { columns } from "./business-dispatch";
import { searchReqParam } from "../../utils/searchReqParam";
import { http } from "../../api/request";
import { saveAs } from "file-saver";
var JSZip = require("jszip");

export default {
	name: "business-dispatch",
	components: { tableFixed, searchForm, controlButtons },
	data() {
		return {
			columns,
			req: searchReqParam(),
			loading: false,
			tableData: [],
			selectedRows: [],
			pagination: {
				showSizeChanger: true,
				defaultPageSize: 10,
				pageSizeOptions: ["10", "15", "50", "100"],
				total: 0,
				current: 1,
				showTotal: (total) => this.$t('totalText', { total }),
				onChange: (page) => {
					this.pagination.current = page;
					this.req.params.page = page;
					this.pageInit();
				},
				onShowSizeChange: (current, pageSize) => {
					this.pagination.current = 1;
					this.req.params.page = 1;
					this.req.params.pageSize = pageSize;
					this.pageInit();
				},
			},
			visibleAttach: false,
			attach: [],
			current: 1,
			currentValue: 1,
			rotateTimes: 0,
			multiples: 1,
			imgStyle: "",
			containerId: "",
			blNumber: "",
			isActive: true,
		};
	},
	watch: {
		loading: {
			handler() {
				this.isActive = !this.loading;
			},
		},
	},
	created() {},
	mounted() {
		this.pageInit();
	},
	methods: {
		// 初始化页面
		pageInit() {
			this.req.params = this.$refs["dispatchSearchRef"].req.params;
			this.loading = true;
			orderlist(this.req).then((res) => {
				let resData = JSON.parse(res.data);
				if (!resData.success || resData.code != "0") {
					this.$message.error(resData.msg);
					return;
				}
				this.loading = false;
				this.tableData = resData.data.list;
				// this.containerId = this.tableData.containerId;
				this.tableData.forEach((element, index) => {
					element["index"] =
						index + 1 + (this.req.params.page - 1) * this.req.params.pageSize;
				});
				this.pagination.total = resData.data.total;
			});
		},
		// 表单搜索
		search(data) {
			this.req.params = data.params;
			this.pagination.onChange(1);
		},
		onSelectChange(selectedRows) {
			this.selectedRows = selectedRows;
		},
		success(msg) {
			console.log(msg);
			this.pageInit();
		},
		// 双击表格行显示装箱单
		dbclickRow(selectedRows) {
			this.selectedRows = selectedRows;
			this.$refs["controlBut"].showPackinglist();
		},
		// 关闭附件预览弹框
		closeAttach() {
			this.visibleAttach = false;
			this.current = 1;
			this.currentValue = 1;
			this.attach = [];
			this.imgStyle = "";
		},
		// 查看附件
		showAttachment() {
			if (this.selectedRows.length >= 1) {
				let params = {
					attachmentTypes: [],
					containerId: "",
				};
				let attach = this.selectedRows[0];
				params.containerId = attach.containerId;
				this.req.params = params;
				// containerId
				this.containerId = attach.containerId;
				this.blNumber = attach.blNumber;

				containerAttachments(this.req).then((res) => {
					this.attach = [];
					let resData = JSON.parse(res.data).data;
					if (resData.length == 0) {
						this.$message.warn(this.$t('businessDispatch.noInformation'));
						return;
					}
					this.attach = this.getAttachments(resData);
					this.visibleAttach = true;
				});
			} else {
				this.$message.error(this.$t('businessDispatch.feedbackTransportNode[0]'))
			}
		},
		// 对附件进行封装
		getAttachments(containerAttachments) {
			let attachments = [];
			containerAttachments.forEach((element, index) => {
				console.log(
					element.url.substr(element.url.lastIndexOf("."), element.url.length)
				);
				let fileType = element.url.substr(
					element.url.lastIndexOf(".") + 1,
					element.url.length
				);
				let name = element.url.substr(
					element.url.lastIndexOf("/") + 1,
					element.url.length
				);
				attachments.push({
					id: index,
					type: fileType,
					fileType: element.fileType,
					url: element.url,
					name: name,
					fileName: element.fileName,
					attachmentId: element.attachmentId,
					blNumber: this.blNumber,
				});
			});
			//  对附件排序
			// attachments.sort((a, b) => {
			// 	return a.type > b.type ? 1 : -1;
			// });
			return attachments;
		},
		//  下载
		downloadFile(attachmentId, name, containerId) {
			let reqParams = {
				meta: this.req.meta,
				params: {
					attachmentId: attachmentId,
					containerId: containerId,
				},
			};
			downloadAttachment(reqParams).then((res) => {
				let blob = res.data;

				let reader = new FileReader();

				reader.readAsDataURL(blob);

				reader.onload = (e) => {
					let a = document.createElement("a");

					a.download = name;

					a.href = e.target.result;

					document.body.appendChild(a);

					a.click();

					document.body.removeChild(a);
				};
			});
		},
		//base64转blob
		base64ToBlob(code) {
			let parts = code.split(";base64,");
			let contentType = parts[0].split(":")[1];
			let raw = window.atob(parts[1]);
			let rawLength = raw.length;

			let uInt8Array = new Uint8Array(rawLength);

			for (let i = 0; i < rawLength; ++i) {
				uInt8Array[i] = raw.charCodeAt(i);
			}
			return new Blob([uInt8Array], { type: contentType });
		},
		//  查看上一个附件
		preImg() {
			if (this.current > 1) {
				window.getSelection
					? window.getSelection().removeAllRanges()
					: document.selection.empty();
				this.current--;
				this.currentValue = this.current;
			}
		},
		// 查看下一个附件
		nextImg() {
			if (this.current < this.attach.length) {
				this.current++;
				this.currentValue = this.current;
			}
		},
		// 快速到达指定页
		onBlur() {
			this.current = this.currentValue;
		},
		keyup(e) {
			e.target.blur();
		},
		// 在线查看文件
		previewFile(url) {
			let pdfUrl = url;
			var i = null;
			var ssl = null;
			var a = pdfUrl.substr(0, 5);
			if (a == "https") {
				i = "21627";
				ssl = "&ssl=1";
			} else {
				pdfUrl = pdfUrl.replace("http", "https");
				i = "21627";
				ssl = "&ssl=1";
			}
			if (pdfUrl.indexOf("yzs-overt.oss-cn-shanghai.aliyuncs.com") != -1) {
				i = "34260";
			}
			if (pdfUrl.indexOf("driverglobe.com") != -1) {
				i = "34260";
			}
			if (pdfUrl.indexOf("tximage.fat.driverglobe.com") != -1) {
				i = "34947";
			}
			return "https://vip.ow365.cn/?i=" + i + ssl + "&furl=" + pdfUrl;
			// window.open("http://vip.ow365.cn/?i=" + i + ssl + "&furl=" + pdfUrl);
		},

		// 批量下载
		async mulDown() {
			let zip = new JSZip();
			for (let i = 0; i <= this.attach.length - 1; i++) {
				let ele = this.attach[i];
				// 本地测试
				// let start = ele.url.indexOf('/', 8);
				// let url = ele.url.slice(start);
				// let res = await http.get(url, {
				// 	baseURL: '/mulDown',
				// 	responseType: 'arraybuffer'
				// });

				// 线上
				let res = await http.get(ele.url, {
					responseType: "arraybuffer",
				});

				zip.file(ele.name, res.data, { binary: true });
			}

			zip.generateAsync({ type: "blob" }).then((content) => {
				saveAs(content, "attachments.zip");
			});
		},
		// 旋转图片
		rotateLeft() {
			// this.$refs.imageBox.style.transform =
			// 	"rotate(" + 90 * this.rotateTimes + "deg)";
			this.rotateTimes++;
			this.imgStyle = `transform: rotate(${90 * this.rotateTimes}deg) scale(${
				this.multiples
			})`;
		},
		// 放大
		toBIgChange() {
			if (this.multiples >= 2) {
				return;
			}
			this.multiples += 0.25;
			this.imgStyle = `transform: rotate(${90 * this.rotateTimes}deg) scale(${
				this.multiples
			})`;
		},
		// 缩小
		toSmallChange() {
			if (this.multiples <= 1) {
				return;
			}
			this.multiples -= 0.25;
			this.imgStyle = `transform: rotate(${90 * this.rotateTimes}deg) scale(${
				this.multiples
			})`; //
		},
		// 实现图片拖拽
		imgMove(e) {
			this.cleanUpDefaultEvent(e);
			let oImg = e.target;
			let disX = e.clientX - oImg.offsetLeft;
			let disY = e.clientY - oImg.offsetTop;
			document.onmousemove = (e) => {
				e.preventDefault();
				let left = e.clientX - disX;
				let top = e.clientY - disY;
				this.imgStyle = this.imgStyle + `left: ${left}px; top:${top}px;`;
			};
			document.onmouseup = () => {
				document.onmousemove = null;
				document.onmousemove = null;
			};
		},
		cleanUpDefaultEvent(event) {
			event = event || window.event || arguments.callee.caller.arguments[0];
			if (event.preventDefault) {
				//IE not have
				event.preventDefault();
			}
			event.returnValue = false;
		},
	},
};
</script>

<style lang="less">
.ant-card-body {
	overflow: auto;
	padding: 0;
}
</style>

<style lang="less" scoped>
//  附件预览开始
.optPage {
	background: white;
	border-radius: 3px;
}
/deep/ .jup {
	width: 30px;
	display: inline-block;
	padding: 0;
	text-align: center;
}
/deep/ .notAllow {
	cursor: not-allowed;
	opacity: 0.5;
}
/deep/ .allow {
	&:hover {
		cursor: pointer;
		color: #1890ff;
	}
}
.imgMask:hover {
	background: black;
	opacity: 0.5;
	.eyeIcon {
		color: white;
		opacity: 1;
	}
}
.eyeIcon {
	opacity: 0;
}
.download {
	margin-left: 15px;
}
.imgBg {
	display: inline-block;
	margin-right: 6px;
}
.previewImage {
	position: relative;
}
.arrows {
	position: absolute;
	top: 45%;
	font-size: 40px;
	width: 96%;
	color: white;
}

/deep/ .dialogClass {
	height: 80% !important;
	width: 60% !important;
}
.buIcon {
	font-size: 60px;
	background: gray;
	opacity: 0.8;
	border-radius: 50%;
}
//  附件预览结束
/deep/ .ant-table-body {
	max-height: 90% !important;
}
// 弹窗内容
@media screen and (max-width: 768px) {
	/deep/ .ant-modal-content {
		width: 1040px;
	}
}
@media screen and (min-width: 768px) {
	/deep/ .ant-modal-content {
		width: 100%;
	}
}
/deep/ .ant-modal-content {
	height: 100%;
	.ant-modal-close {
		height: 6%;
		width: 50px;
		display: flex;
		justify-content: center;
		align-items: center;
		.ant-modal-close-x {
			width: 100%;
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}
	.ant-modal-header {
		height: 6%;
		padding: 0;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.ant-modal-body {
		height: 88%;
		overflow: hidden;
		.ant-pagination-simple .ant-pagination-simple-pager input:nth-child(1) {
			width: 40px;
		}
	}
	.ant-modal-footer {
		height: 6%;
		padding: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		.ant-btn {
			font-size: 12px;
		}
	}
	.imgStyle {
		width: auto;
		height: auto;
		max-width: 100%;
		max-height: 100%;
		position: absolute;
		cursor: pointer;
	}
}

/deep/.ant-table-small.ant-table-bordered .ant-table-content {
	border-right: none !important;
}
.attactment-wrap {
	width: 100%;
	height: 100%;
	position: relative;
	display: flex;
	justify-content: center;
}
.attachment-footer {
	height: 6%;
	position: relative;
	display: flex;
	align-items: center;
	background: #c7c5c5;
	font-weight: bold;
}
.change-img-size {
	position: absolute;
	right: 186px;
}
.opt-left {
	width: 4%;
}
.opt-middle {
	width: 46%;
	text-align: left;
}
.opt-right {
	position: absolute;
	right: 10px;
	width: 150px;
}
// 去除 table 底部多出默认边框
/deep/.ant-table-small.ant-table-bordered {
	border-bottom: 0;
}
// 搜索区固定左贴边
.searchform-style {
	position: sticky;
	left: 0;
	padding: 24px 24px 0px 24px;
	z-index: 101;
}
// 按钮吸顶
.control-tabs {
	height: 40px;
	position: -webkit-sticky;
	position: sticky;
	top: 0;
	left: 0;
	background: white;
	z-index: 100;
	padding: 0 24px;
	display: flex;
	align-items: center;
}
// 表格吸顶
.table-scroll-wrap {
	position: -webkit-sticky;
	position: sticky;
	top: 40px;
	padding: 0 24px;
}
/deep/ .ant-table-thead {
	position: sticky;
	top: 40px;
	background: #f5f5f5;
	z-index: 100;
}
.content-wrap {
	overflow: auto;
	width: 100%;
	height: 100%;
	/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
		margin-bottom: 0;
		padding-bottom: 0;
		overflow: hidden;
		opacity: 0.9999;
	}
	// ::-webkit-scrollbar {
	// 	width: 0px;
	// 	height: 8px;
	// }
}
.active {
	/deep/.ant-table-thead {
		position: sticky;
		top: 40px;
		background: #f5f5f5;
		z-index: 100;
	}
}
.static {
	/deep/.ant-table-thead {
		position: static;
		top: 0px;
		background: #f5f5f5;
		z-index: 100;
	}
}
</style>
